class MediaGalleryModal extends ModalDialog {
  constructor() {
    super();
    this.addEventListener('click', () => this.hide());
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    activeMedia.classList.add('active');
  }
};

window.customElements.define('media-gallery-modal', MediaGalleryModal);


class MediaGalleryGrid extends HTMLElement {
  constructor() {
    super();
    this.galleryThumbs = this.querySelectorAll('.js-thumb-button');
    this.modalButtons = this.querySelectorAll('.js-modal-button');
    this.mediaBlocks = this.querySelectorAll('.js-media-block');

    this.galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', this.handleThumbClick.bind(this));
    });
    this.modalButtons.forEach((button) => {
      button.addEventListener('click', this.handleModalButtonClick.bind(this));
    });
  }

  handleThumbClick(event) {
    const mediaId = event.currentTarget.dataset.mediaId;
    const mediaBlock = this.querySelector(`[data-media-id="${mediaId}"]`);
    if (!mediaBlock) return;

    this.mediaBlocks.forEach((block) => {
      block.classList.remove('active');
    });
    mediaBlock.classList.add('active');
  }

  handleModalButtonClick(event) {
    const galleryId = event.currentTarget.dataset.galleryId;
    const modal = document.getElementById(galleryId);
    if (!modal) return;

    modal.openedBy = event.currentTarget;
    modal.show(event.currentTarget);
  }
};

window.customElements.define('media-gallery-grid', MediaGalleryGrid);